import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatRadioChange } from '@angular/material/radio';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { DialogModel } from '@shared/models/dialog.model';

@Component({
    standalone: false,
    selector: 'particle-add-execution-dialog',
  templateUrl: './add-execution-dialog.component.html',
  styleUrls: ['./add-execution-dialog.component.scss']
})
export class AddExecutionDialogComponent implements OnInit, IDialogView, AfterViewInit {

  data: DialogModel;
  isIndividualResponse: boolean;
  showResponseOption: boolean;
  responseType: string;
  allowCreateNewRecord: boolean;
  showAllowRecipientsOption = true;
  @ViewChild('titleInput', {static: true}) titleInput: ElementRef;
  constructor( private router: Router) {
    if (this.router.url.toLowerCase().includes('filing-manager/forms')) {
      this.showAllowRecipientsOption = false;
    }
  }

  ngOnInit() {
    this.showResponseOption = this.data.input.showResponseOption;
    this.isIndividualResponse = this.data.input.isIndividualResponse === true;
    // this.responseType = this.isIndividualResponse ? 'independent' : 'collaborate';
    // this.allowCreateNewRecord = this.data.input.allowCreateNewRecord === true;
    this.allowCreateNewRecord = true;
    this.responseType = 'independent';
  }
  ngAfterViewInit (): void {
    // this.titleInput.nativeElement.focus();
  }
  onOkClicked(): boolean {
    if (!this.data.input.title || this.data.input.title.length === 0) {
      return false;
    }

    this.data.input.isIndividualResponse = this.responseType === 'independent';
    this.data.input.allowCreateNewRecord = this.allowCreateNewRecord;
    return true;
  }

  onChange($event: MatRadioChange) {

  }
}
